import type {
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";

type BaseProps = {
  label: string;
  helper?: string;
  error?: string;
};

export function TextField({
  label,
  helper,
  error,
  ...props
}: BaseProps & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className="field">
      <span className="field__label">{label}</span>
      <input className="field__control" {...props} />
      {helper && <span className="field__helper">{helper}</span>}
      {error && <span className="field__error">{error}</span>}
    </label>
  );
}

export function TextAreaField({
  label,
  helper,
  error,
  ...props
}: BaseProps & TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <label className="field">
      <span className="field__label">{label}</span>
      <textarea
        className="field__control field__control--textarea"
        {...props}
      />
      {helper && <span className="field__helper">{helper}</span>}
      {error && <span className="field__error">{error}</span>}
    </label>
  );
}

export function SelectField({
  label,
  helper,
  error,
  children,
  ...props
}: BaseProps & SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <label className="field">
      <span className="field__label">{label}</span>
      <select className="field__control" {...props}>
        {children}
      </select>
      {helper && <span className="field__helper">{helper}</span>}
      {error && <span className="field__error">{error}</span>}
    </label>
  );
}
